import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppName, AppUrl } from '../microfrontend.tokens';
import { MfAccountingServiceComponent } from './mf-accounting-service.component';
import { MfAccountingServiceRoutingModule } from './mf-accounting-service-routing.module';
import { MfAccountingServicePlanComponent } from './mf-accounting-service-plan/mf-accounting-service-plan.component';

const microfrontendKey = 'mf-accounting-service';

@NgModule({
  declarations: [
    MfAccountingServiceComponent,
    MfAccountingServicePlanComponent,
  ],
  imports: [CommonModule, MfAccountingServiceRoutingModule],
  exports: [MfAccountingServiceComponent, MfAccountingServicePlanComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: AppName,
      useValue: microfrontendKey,
    },
    {
      provide: AppUrl,
      useFactory: () => {
        return localStorage.getItem(microfrontendKey);
      },
    },
  ],
})
export class MfAccountingServiceModule {}
